module.exports = __webpack_public_path__ + "static/media/0321_IMG_BVP.65848568.webp";